export const formatarNumeroCelular = (number: string) => {
    if (!number) {
        return number;
    }

    const cleaned = number.toString().replace(/\D/g, '');
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return number;
};

export const formatarNumeroTelefone= (number: string) => {
    const cleaned = number.toString().replace(/\D/g, '');
    const match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return number;
};

export const formatarCep = (number: string) => {
    const cleaned = number.toString().replace(/\D/g, '');
    const match = cleaned.match(/^(\d{2})(\d{3})(\d{3})$/);
    if (match) {
        return `${match[1]}.${match[2]}-${match[3]}`;
    }
    return number;
} 